module.exports = __webpack_public_path__ + "img/綠色隧道.2f643968.jpg";